<div class="flex justify-content-center align-items-center">
    <p 
    [style.max-width]="width"
    [pTooltip]="text" tooltipPosition="bottom"
    >
    {{text}}
    </p>
</div>